<template>
  <div class="empty-placehold">
    <div class="empty-placehold-content">
      <img class="empty-img" :src="showImg" alt="">
      <span class="empty-text">{{ulText}}</span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import empty1 from 'assets/images/elephant_empty1.png'
  import loadingImg from './loading.gif'

  export default {
    props: {
      ulImg: {
        type: String,
        default: empty1
      },
      //        0 是小像点位 其它是加载中小象
      ulType: {
        type: Number,
        default: 0
      },
      ulLoadingImg: {
        type: String,
        default: loadingImg
      },
      ulText: {
        default: '没有文字'
      }
    },
    computed: {
      showImg: function () {
        if (this.ulType === 0) {
          return this.ulImg
        } else {
          return this.ulLoadingImg
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "common/stylus/variable.styl"
  .empty-placehold
    .empty-text
      font-size: $font-size-medium
      color: $color-light-dark
      display: inherit
      padding: 0px $public-pading
      text-align: center
      margin-top: 20px

  .web
    .empty-placehold
      text-align: center
      .empty-placehold-content
        padding-top: 80px
        padding-bottom: 60px
        > img
          width: 120px
          height: 120px

  .mobile
    .empty-placehold
      position: absolute
      left: 0
      right: 0
      bottom: 0
      top: 0
      .empty-placehold-content
        height: 100%
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        > img
          max-width: 40%
          margin-bottom: 8px

</style>



// WEBPACK FOOTER //
// src/common/components/universal/emptyPlacehold/emptyPlacehold.vue